import { useState, useEffect, useMemo } from "react";

const usePagination = <T extends [string, any][]>(
  entries: T,
  initialItemsPerPage: number = 10,
  resetPageTrigger?: any
) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);

  const totalItems = entries.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;

  const paginatedEntries = useMemo(() => {
    return entries.slice(startIdx, endIdx);
  }, [entries, startIdx, endIdx]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  useEffect(() => {
    setCurrentPage(1);
  }, [resetPageTrigger]);

  return {
    paginatedEntries,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    totalPages,
    totalItems,
    startIdx,
    endIdx,
  };
};

export default usePagination;
